module.exports = __webpack_public_path__ + "static/media/4.06bf545f.png";